import { render, staticRenderFns } from "./SampleOrdersList.vue?vue&type=template&id=929c73c8&scoped=true"
import script from "./SampleOrdersList.vue?vue&type=script&lang=js"
export * from "./SampleOrdersList.vue?vue&type=script&lang=js"
import style0 from "./SampleOrdersList.vue?vue&type=style&index=0&id=929c73c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929c73c8",
  null
  
)

export default component.exports